// Wendet das `infos`-Layout auf alle Seiten unter /infos/[thema]/ an,
// ohne jede einzelne Seite anpassen zu müssen.
export default defineNuxtRouteMiddleware((to) => {
  const parts = to.path.split('/').filter(Boolean)
  if (parts[0] === 'infos' && parts.length >= 2) {
    setPageLayout('infos')
  }
})
